import {Redirect, useLocation} from "react-router-dom";
import {useOktaAuth} from "@okta/okta-react";
import {useIdps} from "../../contexts/IdpsContext";
import {useEffect, useState} from "react";
import {getApplicationState, NORMAL, setApplicationState, START_LINK_IDP} from "../../services/common";
import {getAppleToken} from "../../services/api/socialIdentityApi";
import {extract} from "../../utils/jwt";
import {toast} from "react-toastify";


const extractSub = (res) => {
	if ('id_token' in res) {
		const idToken = extract(res.id_token);
		return idToken?.sub ?? null;
	}

	return null;
}

const AppleCallback = () => {
	const {search} = useLocation();
	const {authState} = useOktaAuth();
	const {linkIdp} = useIdps();
	const [redirect, setRedirect] = useState(false);

	const searchParams = new URLSearchParams(search);

	const code = searchParams.get('code');

	useEffect(() => {
		if(redirect) {
			return;
		}

		if(!code) {
			setRedirect(true);
			return;
		}

		if(!authState?.accessToken) {
			return;
		}

		(async (code) => {
			const res = await getAppleToken(code);
			const sub = extractSub(res?.data?.data);
			let error = null;

			const appState = getApplicationState();

			if(sub) {
				if(appState.state === START_LINK_IDP) {
					const idpId = appState?.link?.idpId ?? null;

					if(idpId) {
						await linkIdp(idpId, sub);
					}
					else {
						error = 'No idp id found';
					}
				}
				else {
					error = 'Unknown action';
				}
			}
			else {
				error = 'No external id found';
			}

			if(error) {
				toast.error(error);
			}

			appState.state = NORMAL;
			delete appState.link;

			setApplicationState(appState);

			setRedirect(true);
		})(code);
	}, [redirect, setRedirect, linkIdp, authState, code]);

	if (!redirect) {
		return null;
	}

	return (<Redirect to={'/'}/>);
}

export default AppleCallback;
